import dayjs from 'dayjs';

export const compareByAlphabet = (a: string, b: string) => {
  if (a.toLowerCase() > b.toLowerCase()) {
    return 1;
  }

  if (a.toLowerCase() < b.toLowerCase()) {
    return -1;
  }

  return 0;
};

export const compareByDate = (a: string | number | Date, b: string | number | Date) => {
  if (dayjs(a).isAfter(b)) {
    return 1;
  }

  if (dayjs(a).isBefore(b)) {
    return -1;
  }

  return 0;
};
